var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"spinner-with-message",class:_vm.className},[_c('spinner'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.message))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }